/**
 * Deal "Additional notes" - an optional free-text box next to a deal upload, for extra context
 * about the WHOLE deal (not about the files). Saved on the deal as a `knowledge.document` with
 * `source_kind = DEAL_NOTES_SOURCE_KIND` and read, as prompt context only, by the transcript
 * analysis run (questionnaire extraction + scope discovery).
 */
import { z } from 'zod';
/** `knowledge.document.source_kind` of a saved additional-notes document (free text column, no CHECK). */
export const DEAL_NOTES_SOURCE_KIND = 'deal_notes';
/** Title every additional-notes document is saved under. */
export const DEAL_NOTES_DOCUMENT_TITLE = 'Additional notes';
/** Longest additional-notes text accepted (characters), enforced by the UI counter, the route and the AI helper. */
export const DEAL_ADDITIONAL_NOTES_MAX_CHARS = 4000;
/** Body of `POST /api/sales/deals/:dealUuid/additional-notes`. Trimmed first, then 1..4000 chars. */
export const dealAdditionalNotesBodySchema = z.object({
    text: z.string().trim().min(1).max(DEAL_ADDITIONAL_NOTES_MAX_CHARS),
});
//# sourceMappingURL=deal-additional-notes.js.map